const validate = (values) => {
  const errors = {};

  if (!values.question || values.question.trim() === '') {
    errors.question = 'Please enter question';
  }
  return errors;
};
export default validate;



// WEBPACK FOOTER //
// ./src/modules/Masters/components/securityQuestions/validate.js